import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IDevice } from '../../../interfaces/types.ts'
import { faToggleOn } from '@fortawesome/free-solid-svg-icons/faToggleOn'
import { sendCommand } from '../../../helpers/commandHelper.ts'
import { dataState } from '../../../store/dataState.ts'
import toast from 'react-hot-toast'

interface Props {
    iconOnly?: boolean
    tracker: IDevice
}

export const ProvisionDeviceButton: React.FC<Props> = (props) => {
    const {iconOnly, tracker} = props
    const [inProgress, setInProgress] = React.useState(false)

    const doUpgrade = async () => {
       setInProgress(true)
        try {
            const resultData = await sendCommand('provisionDevice', tracker?.iccid || '', null)
            if (resultData) {
                dataState.devices = (resultData)
                toast.success('Device activated')
            } else {
                toast.error('Error, activation failed. Try again later.')
                setInProgress(false)
            }
        } catch (e) {
            toast.error('Fatal Error, activation failed. Try again later.')
            setInProgress(false)
        }
    }

    const button = iconOnly ? (
        <div className={'text-secondary text-xl'} onClick={doUpgrade}>
            <FontAwesomeIcon icon={faToggleOn}/>
        </div>
        ) :
        <button className={'btn btn-xs btn-ghost text-secondary without-ring h-fit'}
                disabled={tracker.isActive || inProgress}
                onClick={doUpgrade}
        >
            Activate Tracker
        </button>

    return (
        <div>
            {button}
        </div>
    )
}
